module.exports = __webpack_public_path__ + "static/cheeseburger-17bdf1135caa20896d67a0c282f5be37.png";